import React, { useEffect, useState } from "react";
import { useMediaQuery } from "@mantine/hooks";
import { Box, Button, Flex, Modal, Pagination, ScrollArea, Select, Skeleton, Text, TextInput, rem } from "@mantine/core";
import { IconCopyPlus, IconSearch } from "@tabler/icons-react";
import classes from "./roleOrg.module.css";
import Sidebar from "../../components/ui/AppShell/Sidebar";
import TableSkeleton from "../../components/ui/TableSkeleton";
import TableRoleOrg from "../../components/pages/roleOrg/TableRoleOrg";
import FormRoleOrg from "../../components/pages/roleOrg/FormRoleOrg";
import FormRolePermissionOrg from "../../components/pages/roleOrg/FormRolePermissionOrg";
import { getListRoleOrg } from "../../services/roleOrg";
import { getListApplication } from "../../services/application";

const defaultParameter = {
  skip: 0,
  take: 10,
  keyword: "",
  applicationId: "",
};

const labelTable = [
  {
    label: "No.",
    width: 30,
  },
  {
    label: "Role",
    width: "auto",
  },
  {
    label: "Application",
    width: "auto",
  },
  {
    label: "Status",
    width: "auto",
  },
  {
    label: "Action",
    width: 100,
  },
];

const RoleOrg = () => {
  const [params, setParams] = useState(defaultParameter);
  const [roleOrgList, setRoleOrgList] = useState([]);
  const [count, setCount] = useState(0);
  const [detailData, setDetailData] = useState(null);
  const [loadingForm, setLoadingForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openModalForm, setOpenModalForm] = useState(false);
  const [openModalPermission, setOpenModalPermission] = useState(false);
  const [selectedApplicationId, setSelectedApplicationId] = useState("");
  const [applicationList, setApplicationList] = useState([]);
  const isSmallScreen = useMediaQuery("(max-width: 425px)");

  const onCloseModalForm = () => {
    setOpenModalForm(false);
    setDetailData(null);
  };

  const onCloseModalPermission = () => {
    setOpenModalPermission(false);
    setDetailData(null);
  };

  const handleGetListApplication = async () => {
    setLoadingForm(true);
    try {
      const response = await getListApplication();
      const dataApplication = response.data;
      const mappingApplication = [
        { value: "", label: "Select aplikasi" },
        ...dataApplication.map((val) => ({
          value: val?.id?.toString(),
          label: val?.name,
        })),
      ];
      setApplicationList(mappingApplication);
    } catch (error) {
      console.log(error);
    }
    setLoadingForm(false);
  };

  const handleGetRoleOrg = async () => {
    setLoading(true);
    try {
      const response = await getListRoleOrg(params);
      setRoleOrgList(response.data);
      setCount(response.count);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetListApplication();
    // eslint-disable-next-line
  }, [selectedApplicationId]);

  useEffect(() => {
    handleGetRoleOrg();
    // eslint-disable-next-line
  }, [params]);

  const handleSearchChange = (e) => {
    const params = {
      skip: 0,
      take: 10,
      keyword: e.target.value,
      applicationId: "",
    };
    setParams(params);
  };

  const handleChangePage = (e) => {
    const params = {
      skip: (e - 1) * 10,
      take: 10,
      keyword: "",
      applicationId: "",
    };
    setParams(params);
  };

  const handleChangeApp = (e) => {
    setSelectedApplicationId(e);
    const params = {
      skip: 0,
      take: 10,
      keyword: "",
      applicationId: e,
    };
    setParams(params);
  };

  const actions = {
    edit: (val) => {
      setOpenModalForm(true);
      setDetailData(val);
    },
    permission: (val) => {
      setOpenModalPermission(true);
      setDetailData(val);
    },
  };

  const handleAction = (val, type) => {
    return actions[type](val);
  };

  return (
    <Sidebar>
      <Box>
        <Text className={classes.titlePage} mb={20}>
          Role Management
        </Text>

        {!loadingForm ? (
          <Box style={{ display: "flex", flexDirection: isSmallScreen ? "column" : "row", justifyContent: "space-between" }}>
            <Flex>
              <TextInput mr={8} leftSectionPointerEvents="none" leftSection=<IconSearch style={{ width: rem(16), height: rem(16) }} /> placeholder="Cari Role. . ." name="search" onChange={handleSearchChange} />
              <Select mr={8} name="applicationId" placeholder="Select aplikasi" searchable nothingFoundMessage="Aplikasi tidak ditemukan" data={applicationList} onChange={handleChangeApp} value={selectedApplicationId} />
            </Flex>

            <Flex mt={isSmallScreen ? 10 : 0}>
              <Button fullWidth={isSmallScreen} leftSection={<IconCopyPlus size={14} />} color="#0572b9" onClick={() => setOpenModalForm(true)}>
                Tambah Role
              </Button>
            </Flex>
          </Box>
        ) : (
          <Box>
            <Skeleton height={40} width="100%" radius="md" mb="md" />
          </Box>
        )}

        <Box my={20}>{loading ? <TableSkeleton total={5} /> : <TableRoleOrg label={labelTable} data={roleOrgList} countData={params.skip} actionMethod={handleAction} />}</Box>
        <Flex justify="end">
          <Pagination onChange={handleChangePage} total={Math.ceil(count / params.take) || 0} color="#0572b9" radius="lg" />
        </Flex>
        <Modal
          opened={openModalForm}
          onClose={onCloseModalForm}
          centered
          closeOnClickOutside={false}
          size="lg"
          title={<Text fw="Bold">{detailData ? "Edit Role" : "Tambah Role"}</Text>}
          scrollAreaComponent={ScrollArea.Autosize}
          withCloseButton={false}
        >
          <FormRoleOrg dataRoleOrg={detailData} onCloseModal={onCloseModalForm} reloadList={handleGetRoleOrg} />
        </Modal>
        <Modal opened={openModalPermission} onClose={onCloseModalPermission} centered closeOnClickOutside={false} size="lg" title={<Text fw="Bold">Edit Permission</Text>} scrollAreaComponent={ScrollArea.Autosize} withCloseButton={false}>
          <FormRolePermissionOrg dataRoleOrg={detailData} onCloseModal={onCloseModalPermission} reloadList={handleGetRoleOrg} />
        </Modal>
      </Box>
    </Sidebar>
  );
};

export default RoleOrg;
